module.exports = __webpack_public_path__ + "img/kleisma1m-m@1.08738a0d.jpg";